import createReducer, { mergeReducers } from "../../../lib/createReducer";
import { RECEIVED_JOB_ERROR, RECEIVED_JOB_REQUEST, RECEIVED_JOB_SUCCESS } from "./action";

const init = {
  job: null,

  isFetching: false,
  fetchSuccess: false,
  hasError: false,
  payload: null,
  error: null,
};

const requestReducer = createReducer(
  RECEIVED_JOB_REQUEST,
  ({ job }) => ({
    ...init,
    job,
    isFetching: true,
  }),
  true
);

const successReducer = createReducer(RECEIVED_JOB_SUCCESS, ({ response }) => ({
  isFetching: false,
  fetchSuccess: true,
  payload: response,
}));

const errorReducer = createReducer(RECEIVED_JOB_ERROR, ({ error }) => ({
  isFetching: false,
  hasError: true,
  error,
}));

export default mergeReducers([requestReducer, successReducer, errorReducer], init);
